function initGummyFaq(currentSection) {
  const gummyFaqItems = currentSection.querySelectorAll('.gummy-faq-item button');
  const animatedElement = currentSection.querySelector('.gummy-faq__animated-element');

  function toggleGummyFaqActive() {
    const faqItem = this.closest('.gummy-faq-item');
    const content = faqItem.querySelector('.gummy-collapsible-content');

    faqItem.classList.toggle('active');
    this.classList.toggle('is-open');

    if (faqItem.classList.contains('active')) {
      content.style.maxHeight = content.scrollHeight + 'px';
      content.style.opacity = '1';
    } else {
      content.style.maxHeight = '0';
      content.style.opacity = '0';
    }
  }

  gummyFaqItems.forEach(function(item) {
    item.addEventListener('click', toggleGummyFaqActive);
  });

  const imageWrapper = currentSection.querySelector('.gummy-faq__image-wrapper');
  if (animatedElement && imageWrapper) {
    const observer = new IntersectionObserver(function(entries) {
      entries.forEach(function(entry) {
        if (entry.isIntersecting) {
          animatedElement.classList.add('active');
        } else {
          animatedElement.classList.remove('active');
        }
      });
    }, { threshold: 1.0, rootMargin: '0px' });

    observer.observe(imageWrapper);
  }
}

document.querySelectorAll('[id^="GummyFaq-"]:not([data-faq-init])').forEach(function(section) {
  section.dataset.faqInit = '1';
  initGummyFaq(section);
});

document.addEventListener('shopify:section:load', function(e) {
  const section = e.target.querySelector('[id^="GummyFaq-"]');
  if (section && !section.dataset.faqInit) {
    section.dataset.faqInit = '1';
    initGummyFaq(section);
  }
});
